import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Mail, MapPin, Phone } from "lucide-react";
export default function ContactUs() {
  return <section className="relative bg-background py-16 md:py-24">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-12 text-center">
          <h2 className="mb-4 font-display text-3xl font-bold tracking-wide text-foreground md:text-4xl">
            Contact Us
          </h2>
          <p className="mx-auto max-w-2xl font-sans text-base leading-relaxed text-muted-foreground">
            Get in touch with Align Physiotherapy. We're here to help you move better and feel better.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {/* Contact Form */}
          <div className="animate-fade-in-up">
            <Card className="border border-border bg-background shadow-soft">
              <CardHeader>
                <CardTitle className="font-display text-2xl font-semibold text-foreground">
                  Send Us a Message
                </CardTitle>
              </CardHeader>
              <CardContent>
                <form className="space-y-6">
                  <div className="space-y-2">
                    <Label htmlFor="name">Full Name</Label>
                    <Input id="name" type="text" placeholder="Enter your full name" className="w-full rounded-md border border-border bg-background px-4 py-2 text-foreground shadow-xs transition-all focus:border-primary focus:ring-2 focus:ring-primary/20" />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="email">Email Address</Label>
                    <Input id="email" type="email" placeholder="your.email@example.com" className="w-full rounded-md border border-border bg-background px-4 py-2 text-foreground shadow-xs transition-all focus:border-primary focus:ring-2 focus:ring-primary/20" />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="phone">Phone Number</Label>
                    <Input id="phone" type="tel" placeholder="+44 1302 000000" className="w-full rounded-md border border-border bg-background px-4 py-2 text-foreground shadow-xs transition-all focus:border-primary focus:ring-2 focus:ring-primary/20" />
                  </div>

                  <div className="space-y-2">
                    <Label htmlFor="message">Message</Label>
                    <Textarea id="message" placeholder="Tell us how we can help you..." className="min-h-32 w-full rounded-md border border-border bg-background px-4 py-2 text-foreground shadow-xs transition-all focus:border-primary focus:ring-2 focus:ring-primary/20" />
                  </div>

                  <Button type="submit" className="w-full rounded-lg bg-primary px-6 py-3 font-semibold text-primary-foreground shadow-md transition-all duration-150 ease-in-out hover:bg-primary-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-primary-active active:translate-y-0">
                    Send Message
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>

          {/* Contact Information */}
          <div className="space-y-8 animate-fade-in-up-delay-100">
            {/* Contact Details Card */}
            <Card className="border border-border bg-background shadow-soft">
              <CardHeader>
                <CardTitle className="font-display text-2xl font-semibold text-foreground">
                  Get in Touch
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-accent/10">
                    <MapPin className="size-5 text-accent" />
                  </div>
                  <div>
                    <h4 className="mb-1 font-semibold text-foreground">Address</h4>
                    <p className="text-sm text-muted-foreground">5 Mill Lane, Warmsworth, Doncaster, DN4 9RG, UK</p>
                  </div>
                </div>

                

                <div className="flex items-start gap-4">
                  <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-accent/10">
                    <Mail className="size-5 text-accent" />
                  </div>
                  <div>
                    <h4 className="mb-1 font-semibold text-foreground">Email</h4>
                    <p className="text-sm text-muted-foreground">
                      appointments@alignphysiotherapy.co.uk
                    </p>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-border">
                  <h4 className="mb-2 font-semibold text-foreground">Opening Hours</h4>
                  <p className="text-sm text-muted-foreground leading-relaxed"></p>
                </div>
              </CardContent>
            </Card>

            {/* Map */}
            <div className="overflow-hidden rounded-lg border border-border shadow-soft">
              <iframe src="https://www.google.com/maps?q=5+Mill+Lane,+Warmsworth,+Doncaster+DN4+9RG&output=embed" width="100%" height="256" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Align Physiotherapy location map - 5 Mill Lane, Warmsworth, Doncaster, DN4 9RG" className="w-full h-64" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}